export const GET_LIST: string = "GET_LIST";
export const GET_LIST_SUCCESS: string = "GET_LIST_SUCCESS";
export const GET_LIST_FAILURE: string = "GET_LIST_FAILURE";
export const GET_LOGIN_ERROR: string = "GET_LOGIN_ERROR";
export const LOGIN_SUCCESS: string = "LOGIN_SUCCESS";
export const SHOW_PROGRESS: string = "SHOW_PROGRESS";
export const HIDE_PROGRESS: string = "HIDE_PROGRESS";
export const LOGOUT_USER: string = "LOGOUT_USER";
export const SET_USER_INFO: string = "SET_USER_INFO";
export const REGISTRATION_SUCCESS: string = "REGISTRATION_SUCCESS";
export const RESET_REGISTRATION_SUCCESS: string = "RESET_REGISTRATION_SUCCESS";
export const SET_USERS_LIST: string = "SET_USERS_LIST";
export const RESET_EMAIL_SENT: string = "RESET_EMAIL_SENT";
export const PASSWORD_RESET_SUCCESSFULLY: string =
  "PASSWORD_RESET_SUCCESSFULLY";
export const RESET_REDIRECT_STATE: string = "RESET_REDIRECT_STATE";
